import { LOGOUT_FORCED } from '../mutation-types';

const state = {

    status: false

};

const mutations = {

    [ LOGOUT_FORCED ] ( state, status ) {

        state.status = status;

    }

};

export default {

    state,
    mutations

};



// WEBPACK FOOTER //
// ./src/store/modules/logoutForced.js